import { useMemo } from 'react';
import { useRealplayStore } from 'features/realplays/RealPlays.store';

const RealPlayQualifiedDataHelper = () => {
  //values
  const { realPlayReviewToQualified, realPlayTranscription } = useRealplayStore();

  const final_decision = useMemo(
    () => realPlayReviewToQualified?.final_decision,
    [realPlayReviewToQualified?.final_decision]
  );
  const rating_criteria = useMemo(
    () => realPlayReviewToQualified?.rating_criteria,
    [realPlayReviewToQualified?.rating_criteria]
  );

  const comment = useMemo(
    () => realPlayReviewToQualified?.feedback,
    [realPlayReviewToQualified?.feedback]
  );

  const summary = useMemo(
    () => realPlayReviewToQualified?.summary,
    [realPlayReviewToQualified?.summary]
  );

  const feedback = useMemo(
    () => realPlayReviewToQualified?.feedback,
    [realPlayReviewToQualified?.feedback]
  );

  const status_ai = useMemo(
    () => realPlayReviewToQualified?.status,
    [realPlayReviewToQualified?.status]
  );

  const isEditing = useMemo(
    () => realPlayReviewToQualified?.isEditing,
    [realPlayReviewToQualified?.isEditing]
  );

  //functions
  const { setIsEditing, setFeedback, setRatingCriteria, setDiscardChanges } = useRealplayStore();

  return {
    transcription: realPlayTranscription,
    final_decision,
    rating_criteria,
    comment,
    summary,
    feedback,
    status_ai,
    isEditing,
    setIsEditing,
    setFeedback,
    setRatingCriteria,
    setDiscardChanges,
  };
};

export default RealPlayQualifiedDataHelper;
